module.exports = __webpack_public_path__ + "img/Logo-FFW.71e21ab1.png";